// export const BASE_API_URL = "http://192.168.1.26:8085";
export const BASE_API_URL = "http://122.166.195.74";

